import { CaptainsDocument } from '../types/ViewModel/CaptainsDocument';
import { CaptainsDocumentBM } from '../types/BusinessModel/CaptainsDocumentBM';

export class CaptainsDocumentFactory {
    public newCaptainsDocument(captainsDocument: CaptainsDocumentBM): CaptainsDocument {
        return new CaptainsDocument(
            captainsDocument.captainsDocumentId,
            captainsDocument.reportName,
            captainsDocument.reportHeading,
            captainsDocument.printMethodName
        );
    }

    public createCaptainsDocument(captainsDocument: CaptainsDocument | null): CaptainsDocument | null {
        if (captainsDocument) {
            return new CaptainsDocument(
                captainsDocument.captainsDocumentId,
                captainsDocument.reportName,
                captainsDocument.reportHeading,
                captainsDocument.printMethodName
            );
        }
        return null;
    }
}
